import React from 'react'
// libs
import styled from 'styled-components'
import { Droppable, Draggable } from 'react-beautiful-dnd'
// components
import {
  DropContainer,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/view'
// view components
import Property from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property'
// themes
import { colors } from 'themes'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// constants
import { PROPERTIES_LISTS } from 'constants/objects'
// context
import { ObjectsBLContext } from 'containers/ObjectsAndProperties/Edit/layers/BL'
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'

// styled
const Wrapper = styled('div')`
  margin-right: 80px;
  width: 30%;

  & > div:first-child {
    font-weight: 500;
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }

  .MuiAccordion-root {
    margin-top: 18px;
  }
`

const GlobalProperties: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(true)

  const { object } = React.useContext(ObjectsAPIContext)
  const { globalProperties, isDropDisabled } = React.useContext(ObjectsBLContext)

  const objectName = object.name.toLowerCase()

  const expandPanel = (_, expanded: boolean) => setIsOpen(expanded)

  return (
    <Wrapper>
      <div>Global Properties</div>
      <Accordion expanded={isOpen} onChange={expandPanel}>
        <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>
          <div> About this {objectName}</div>
        </AccordionSummary>
        <AccordionDetails>
          <Droppable droppableId={PROPERTIES_LISTS.GLOBAL} isDropDisabled={isDropDisabled.GLOBAL}>
            {(provided) => (
              <DropContainer ref={provided.innerRef} data-testid='global-properties-drop-area'>
                {globalProperties.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => {
                      return (
                        <>
                          <Property
                            innerRef={provided.innerRef}
                            property={item}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          />
                          {snapshot.isDragging && snapshot.draggingOver === PROPERTIES_LISTS.PLAN_TYPE && (
                            <Property property={item} />
                          )}
                        </>
                      )
                    }}
                  </Draggable>
                ))}
                {provided.placeholder}
              </DropContainer>
            )}
          </Droppable>
        </AccordionDetails>
      </Accordion>
    </Wrapper>
  )
}

export default GlobalProperties
